module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/administracion/categorias-gastos/categorias-gastos-modal/categorias-gastos-modal.component.scss
// module id = ./src/app/administracion/categorias-gastos/categorias-gastos-modal/categorias-gastos-modal.component.scss
// module chunks = main